import React, { Component } from 'react';
import { Button, Row, Col, Modal, Form, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { withTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { duotone, solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import SignalRService from '../../controllers/SignalRService';
import BlockUi from 'react-block-ui';
import 'react-block-ui/style.css';

class Categories extends Component {

    constructor(props) {
        super(props)
        this.state = {
            categories: [],
            category: "",
            loading: false
        }

        this.setLoading = this.setLoading.bind(this);
        this.changeCategory = this.changeCategory.bind(this);
        this.setCategories = this.setCategories.bind(this);
        SignalRService.registerCategoriesList(this.setCategories);
    }

    changeCategory = e => {
        this.setState({
            category: e.target.value
        });
    };

    setLoading(value) {
        this.setState({
            loading: value
        });
    }

    showModal = e => {
        this.setLoading(true);
        SignalRService.getCategories({
            "extension": this.props.extension,
            "userId": this.props.userId,
            "groupId": 0
        });
    }

    setCategories(categories) {
        let data = [""].concat(categories);
        this.setState({
            categories: data
        });
        this.setLoading(false);
    }

    setCategory = e => {

        SignalRService.setCallCategory({
            "extension": this.props.extension,
            "userId": this.props.userId,
            "value": this.state.category
        });

        this.props.toggleModal();
    }

    render() {
        return (<Modal show={this.props.show} onHide={this.props.toggleModal} onShow={this.showModal} size="lg">
            <BlockUi tag="div" blocking={this.state.loading} color="#009ef7" message={this.props.t("pleasewait")}>
                <Modal.Header >
                    <Modal.Title><FontAwesomeIcon icon={duotone('tag')} /> {this.props.t("categories")}</Modal.Title>
                    <OverlayTrigger
                        placement="left"
                        delay={{ show: 250, hide: 400 }}
                        overlay={<Tooltip style={{ position: "fixed" }}>
                            {this.props.t("close")}
                        </Tooltip>}>
                        <Button onClick={this.props.toggleModal} className='float-end'><FontAwesomeIcon icon={solid('xmark')} /></Button>
                    </OverlayTrigger>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col>
                            <Form>
                                <Form.Group className="mb-4" controlId="fcCategory">
                                    <Form.Label>{this.props.t("category")}</Form.Label>
                                    <Form.Select onChange={this.changeCategory} value={this.state.category} >
                                        {
                                            this.state.categories.map(elem => {
                                                return <option key={elem} value={elem}>{elem}</option>
                                            })
                                        }
                                    </Form.Select>
                                </Form.Group>
                            </Form>
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={this.setCategory}>
                        <FontAwesomeIcon icon={duotone("paper-plane-top")} />  {this.props.t("send")}
                    </Button>
                </Modal.Footer>
            </BlockUi>
        </Modal >)
    }
}

export default withTranslation()(Categories);